<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    mobile: { type: Boolean },
    button: { type: Boolean },
    linkParams: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['locale']),
    to() {
      let { to } = this.linkParams
      // to params defined ?
      to.params === undefined
        ? (to.params = { locale: this.locale }) // define and assign locale
        : (to.params.locale = this.locale) // assign locale
      return to
    },
    color() {
      const { color } = this.linkParams
      return color ? color : 'primary'
    },
    text() {
      const { text, mobile } = this.linkParams
      return this.mobile && mobile && mobile.text ? mobile.text : text
    }
  }
}
</script>
<template>
  <v-list-item
    v-if="mobile && linkParams.restriction()"
    :id="linkParams.id + 'Mobile'"
    :to="to"
    @click="$emit('click')" >
    <slot>
      <v-list-item-icon>
        <v-icon :color="color" large>{{ linkParams.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ text }}</v-list-item-title>
      </v-list-item-content>
    </slot>
  </v-list-item>
  <v-btn
    v-else-if="button && linkParams.restriction()"
    :id="linkParams.id + 'Button'"
    :to="to"
    :color="color"
    icon >
    <v-icon large>{{ linkParams.icon }}</v-icon>
  </v-btn>
  <router-link
    v-else-if="linkParams.restriction()"
    :id="linkParams.id"
    :to="to">
    <slot>
      <v-btn :to="to" :color="color" text
      ><v-icon light left>{{ linkParams.icon }}</v-icon
      >{{ text }}</v-btn>
    </slot>
  </router-link>
</template>
<style lang="scss" scoped>
.v-btn {
  height: 100% !important;
  &:hover {
    color: #d9534f !important;
  }
}
.v-list-item__title {
  font-size: 18px !important;
  line-height: 1.2rem !important;
}
</style>
